// extracted by mini-css-extract-plugin
export default {"annotation":"FileViewerPage-styles-module--annotation--VK9Ya","disabled":"FileViewerPage-styles-module--disabled--bMdbd","button":"FileViewerPage-styles-module--button--uSbHx"};